import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import { DASHBOARD_TEACHER, GLOBAL_STATE } from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const TEACHER_DASHBOARD = GLOBAL_STATE

const teacherDashboardSlice = createSlice({
  name: TEACHER_DASHBOARD,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.dashboardTeacher.pending, state => {
        state[DASHBOARD_TEACHER].loading = true
      })
      .addCase(actionCreators.dashboardTeacher.rejected, (state, action) => {
        state[DASHBOARD_TEACHER].loading = false
        state[DASHBOARD_TEACHER].error = action.payload as AxiosError
      })
      .addCase(actionCreators.dashboardTeacher.fulfilled, (state, action) => {
        state[DASHBOARD_TEACHER].loading = false
        state[DASHBOARD_TEACHER].error = null
        state[DASHBOARD_TEACHER].data = action.payload
      })
    builder.addCase(actionCreators.dashboardTeacherClear, state => {
      state[DASHBOARD_TEACHER] = defaultState()
    })
  },
})

export const { reducer: teacherDashboardReducer } = teacherDashboardSlice
